import Button from "@mui/material/Button"
import CircularProgress from "@mui/material/CircularProgress"
import Typography from "@mui/material/Typography";
import { PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js"
import { useEffect, useState } from "react";
import { useOutletContext, useSearchParams } from "react-router-dom";
import http from "../../../libs/http";

function StripeCheckout(){
	const stripe = useStripe()
	const elements = useElements()
	const data = useOutletContext()
	const [queryParams] = useSearchParams()
	const [err,setErr] = useState()
	const [customer,setCustomer] = useState()
	const [csk,setCsk] = useState()
	const [loading,setLoading] = useState(false)
	const done = queryParams.get("done")
	const handleError = (error) => {
		setLoading(false)
		setErr(error.message)
	}
	const onSubmit = async(ev) => {
		ev.preventDefault()
		if(!stripe) return
		setLoading(true)
		const {error: submitError} = await elements.submit()
		if(submitError){
			handleError(submitError)
			return
		}
		const {error} = await stripe.confirmSetup({
			elements,
			clientSecret: csk,
			confirmParams:{
				return_url: `${data?.baseDir}/payment/${data?.id}/setup?done=1`,
			}
		})
		if(error) return handleError(error)
	}
	useEffect(()=>{
		if(done){
			if(!loading && customer === undefined){
				setLoading(true)
				http.post({url:"subscriptions/finishStripeSetup",body:{_id: data?.id}}).then(res=>{
					setCustomer(true)
					setLoading(false)
					if((res.status === 400 && res.data === "Already paid") || res.status === 200) window.location.href = `../${data?.id}`
					console.log("done")
					console.log(res)
				})
			}
			return
		}
		if(customer === undefined && !loading && !err){
			setLoading(true)
			http.get({url:"subscriptions/getStripeCustomer"}).then(res=>{
				console.log({t:"get",status:res.status,data:res.data})
				if(res.status === 200){
					setCustomer(true)
					setCsk(res.data.csk)
					setLoading(false)
				}else if(res.status === 404){
					http.post({url:"subscriptions/saveStripeCustomer"}).then(res=>{
						console.log({status:res.status,data:res.data})
						if(res.status === 400){
							setCustomer(false)
							return setLoading(false)
						}
						if(res.status === 200){
							setCsk(res.data.csk)
							setCustomer(true)
						}else setCustomer(false)
					})
				}else{
					setLoading(false)
					setCustomer(false)
				}
			})
		}
	}, [customer, data?.id, done, err, loading])
	console.log({loading,customer})
	if(done){
		if(loading || customer === undefined) return <CircularProgress sx={{mx:"auto",my:2}}/>
		return <Typography>Método de pago guardado, el pago se procesará en un momento.</Typography>
	}
	return <form onSubmit={onSubmit}>
		<PaymentElement/>
		<Button disabled={!stripe || (loading || !customer)} variant="contained" sx={{mt:2}} type="submit">Confirmar</Button>
		{err && <Typography color="error">{err}</Typography>}
	</form>
}
export default StripeCheckout